module.exports = __webpack_public_path__ + "img/Hand-p-500.e4d8eb51.png";